import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=4614dcb5&scoped=true&"
import script from "./appoint.vue?vue&type=script&lang=js&"
export * from "./appoint.vue?vue&type=script&lang=js&"
import style0 from "./appoint.vue?vue&type=style&index=0&id=4614dcb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614dcb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4614dcb5')) {
      api.createRecord('4614dcb5', component.options)
    } else {
      api.reload('4614dcb5', component.options)
    }
    module.hot.accept("./appoint.vue?vue&type=template&id=4614dcb5&scoped=true&", function () {
      api.rerender('4614dcb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bussiness/appoint.vue"
export default component.exports